import { useTranslation } from 'react-i18next'
import { Field, Form } from 'react-final-form'
import { InputField, SelectField } from 'components/Inputs/Inputs'
import { TableActions } from 'components/TableActions/TableActions'
import { Table } from 'components/TableComponents/Table'
import { Link } from 'react-router-dom'
import plus from 'assets/images/plus.svg'
import Actions from 'components/Actions/Actions'
// import { useGetTrafficUsersQuery, useDeleteTrafficUsersMutation } from 'redux/store/actions'
import { useState } from 'react'
import dayjs from 'dayjs'
import { useDeletePackageMutation, useShowAllPackagesQuery } from 'redux/store/packages/PackagesAPI'
import { useGetHotelGeneralConfigrationQuery } from 'redux/store/actions'
import { useSelector } from 'react-redux'
// import { TrafficUserDetailsInfoDTO, TrafficUserListParams } from 'types/ApiTypes'

export default function Packages(): JSX.Element {
  const { t } = useTranslation()
  const [state, setState] = useState({ offset: 0, limit: 20 })
  const { data } = useShowAllPackagesQuery(state)
  const { data: configrations } = useGetHotelGeneralConfigrationQuery({})
  const [deletePackages] = useDeletePackageMutation()
  const permitions = useSelector((state: any) => state.UserInfo.user.Permissions)
  const PackagePer = permitions?.find((ele: any) => ele.Module === 'Package')

  const onSubmit = (values: any): void => {
    const fullValues = {
      PackageName: undefined,
      PackageType: undefined,
      ...values,
    }
    setState({ ...state, ...fullValues })
  }

  const tableHeaders = [
    {
      title: 'Package ID',
      width: '',
      value: 'Id',
    },
    { title: 'Package Name', width: '', value: 'Name' },
    { title: 'Package Type', width: '', value: 'PackageType' },
    { title: 'Class', width: '', value: 'Class' },
    { title: 'Capacity', width: '', value: 'Capacity' },
    {
      title: 'Starting Date',
      width: '',
      renderCell(row: any) {
        return dayjs(row.StartDate).format('DD/MM/YYYY')
      },
    },
    {
      title: 'Ending Date',
      width: '',
      renderCell(row: any) {
        return dayjs(row.EndDate).format('DD/MM/YYYY')
      },
    },
    {
      title: 'Status',
      width: '',
      value: 'IsInActive',
      renderCell(row: any) {
        return row.IsInActive === true ? (
          <div className="text-[#00AE00]"> {t('Active')} </div>
        ) : (
          <div className="text-[#DF0000]"> {t('Inactive')} </div>
        )
      },
    },
    {
      title: 'Options',
      width: '',
      value: 'Options',
      renderCell(row: any) {
        return (
          <Actions
            delete={{
              handleDelete: () => {
                return deletePackages(row?.Id?.toString() || '')
              },
            }}
            Module="Package"
            editLink={`/admin/packages/edit/${row.Id}`}
            viewLink={`/admin/packages/view/${row.Id}`}
          />
        )
      },
    },
  ]

  return (
    <div className="">
      <div className="w-full flex justify-end py-3">
        {PackagePer.Reservation && (
          <Link
            to="/admin/packages/reservation"
            className="btn-alternative  w-[200px] text-center flex text-sm justify-center items-center		">
            <img src={plus} alt="plus" className="w-[15px] h-[15px]  me-2 font-extrabold	" />
            {t('Add Reservation')}
          </Link>
        )}
        <div className="px-1" />

        {PackagePer.Add && (
          <Link
            to="/admin/packages/create"
            className="btn-alternative  w-[200px] text-center flex text-sm justify-center items-center		">
            <img src={plus} alt="plus" className="w-[15px] h-[15px]  me-2 font-extrabold	" />
            {t('Add Package')}
          </Link>
        )}
      </div>
      <div className="white-container">
        <Form
          onSubmit={onSubmit}
          initialValues={{}}
          render={({ handleSubmit, form, submitting, pristine, modifiedSinceLastSubmit }) => (
            <form onSubmit={handleSubmit} className="">
              <div className="  ">
                <div className="w-full flex flex-wrap items-end">
                  <div className="w-1/5 p-1">
                    <Field
                      label="Package Name"
                      name="packageName"
                      type="text"
                      render={InputField}
                    />
                  </div>
                  <div className="w-1/5 p-1">
                    <Field
                      label="Package Type"
                      name="packageTypeId"
                      render={SelectField}
                      options={configrations?.data?.PackageTypes || []}
                      valueField="Id"
                      textField="Value"
                    />
                  </div>
                  <div className=" w-1/5 mb-1 flex ">
                    <div className="px-1 w-1/2">
                      <button
                        className="btn-alternative text-sm	w-full cursor-pointer"
                        type="button"
                        disabled={submitting || (!modifiedSinceLastSubmit && pristine)}
                        onClick={() => {
                          form.reset()
                          setState({ offset: state.offset, limit: state.limit })
                        }}>
                        {t('Clear All')}
                      </button>
                    </div>
                    <div className="w-1/2">
                      <button
                        className="btn-primary w-full text-sm"
                        type="submit"
                        disabled={submitting || pristine}>
                        {t('Search')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        />
      </div>
      <TableActions endPoint="package" headers={tableHeaders} />
      <div>
        <Table
          // indexKey="id"
          // listName="inventoryList"
          tableHeaders={tableHeaders}
          elements={data?.Items?.Items || []}
          pagination={{
            totalItems: data?.Items?.TotalCount,
            onPaginationChange: (e: any) => {
              setState({ ...state, ...e })
            },
          }}
        />
      </div>
    </div>
  )
}
